import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-drug-frequency-buttons',
    templateUrl: './drug-frequency-buttons.component.html',
    styleUrls: ['./drug-frequency-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrugFrequencyButtonsComponent {
    @Input() frequency;
    @Input() invalid = false;
    @Input() readonly = false;
    @Output() frequencyToggle = new EventEmitter<string>();

    frequencyOptions = [
        { key: 'morning', labelKey: 'inclusion.immunosuppresseur.frequency.morning' },
        { key: 'noon', labelKey: 'inclusion.immunosuppresseur.frequency.noon' },
        { key: 'evening', labelKey: 'inclusion.immunosuppresseur.frequency.evening' },
    ];

    isFrequencySelected(optionKey: string): boolean {
        return !!this.frequency?.[optionKey];
    }

    toggleFrequency(optionKey: string): void {
        if (this.readonly) {
            return;
        }

        this.frequencyToggle.emit(optionKey);
    }
}
